import React from "react";
import { useNavigate } from "react-router-dom";
import { useDefaultRoute } from "../hooks/useDefaultRoute";
import { UserProvider } from "../contexts/UserContext";

function Unauthorized({ children }) {
  return (
    <UserProvider>
      <UnauthorizedContent>{children}</UnauthorizedContent>
    </UserProvider>
  );
}

const UnauthorizedContent = () => {
  const navigate = useNavigate();
  const { getPreferredRoute } = useDefaultRoute();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 text-red-500">
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Accès non autorisé
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Vous n'avez pas les permissions nécessaires pour accéder à cette
            page.
          </p>
        </div>
        <div className="mt-8 space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            Retour à la page précédente
          </button>
          <button
            onClick={() => navigate(getPreferredRoute())}
            className="group relative w-full flex justify-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
